@if (showSuggestions()) {
  <!-- `mousedown` is suppressed so pressing a suggestion never blurs the search input first —
       a real mouse click fires `mousedown` (focus moves, `blur` fires on the input) BEFORE
       `click`, and the input's `(blur)` collapses this panel (gated on `focused()`) out from
       under the still-in-flight click. Same pattern as chat-window's mention list. -->
  <div class="intent-search__suggestions" data-testid="intent-search-suggestions" (mousedown)="$event.preventDefault()">
    @if (history.recent().length > 0) {
      <div class="intent-search__group">
        <div class="intent-search__group-heading">{{ 'header.intentSearchRecentHeading' | translate }}</div>
        @for (recentQuery of history.recent(); track recentQuery) {
          <button type="button" class="intent-search__suggestion" (click)="onSelectQuery(recentQuery)">
            {{ recentQuery }}
          </button>
        }
      </div>
    }
    @for (group of suggestions.groups(); track group.key) {
      @if (group.items.length > 0) {
        <div class="intent-search__group">
          <div class="intent-search__group-heading">{{ groupHeadingKey(group.key) | translate }}</div>
          @for (item of group.items; track item.query) {
            <button type="button" class="intent-search__suggestion" (click)="onSelectQuery(item.query)">
              {{ suggestionLabel(group.key, item) }}
            </button>
          }
        </div>
      }
    }
    <div class="intent-search__examples">
      {{ 'header.intentSearchTryPrefix' | translate }}
      @for (example of searchExamples; track example) {
        <button type="button" class="intent-search__suggestion" (click)="onSelectQuery(example)">
          {{ example }}
        </button>
      }
    </div>
  </div>
} @else if (unsupportedMatch()) {
  <!-- Same `mousedown` suppression as the suggestions panel above, and for the same reason —
       this branch also renders `.intent-search__suggestion` buttons. -->
  <div class="intent-search__unsupported" data-testid="intent-search-unsupported" (mousedown)="$event.preventDefault()">
    <div>{{ 'header.intentSearchUnsupported' | translate }}</div>
    @for (item of closestGroupItems(unsupportedMatch()!); track item.query) {
      <button type="button" class="intent-search__suggestion" (click)="onSelectQuery(item.query)">
        {{ suggestionLabel(closestGroupKey(unsupportedMatch()!), item) }}
      </button>
    }
  </div>
} @else if (interpretations().length > 0) {
  <ul class="intent-search__list" role="listbox">
    @for (spec of interpretations(); track $index) {
      <li class="intent-search__row" data-testid="intent-search-row"
        [class.intent-search__row--active]="$index === highlightedIndex()"
        (click)="onRowClick(spec)">
        {{ rowLabel(spec) }}
      </li>
    }
  </ul>
} @else if (showNoMatch()) {
  <div class="intent-search__no-match" data-testid="intent-search-no-match">
    {{ 'header.intentSearchNoMatch' | translate: { term: query() } }}
  </div>
}
